<template>
    <v-row>
        <v-col cols="4">
            <v-card class="total-report-card">
                <v-card-title>
                    <div class="report-title">
                        Báo cáo tổng
                    </div>
                </v-card-title>
                <v-card-text v-if="!_.isEmpty(totalData)">
                    <div class="total-wrapper" style="margin-top: calc(52% - 159px)">
                        <v-row>
                            <v-col cols="2" class="text-center">
                                <b>VNĐ</b>
                            </v-col>
                            <v-col cols="10" class="text-left total-value">
                                {{ formatPrice(parseFloat(_.get(totalData, 'successTurnOver', 0))) }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="1" class="py-0"></v-col>
                            <v-col cols="11" class="text-left py-0 total-sub-text">
                                Doanh thu thành công
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-right pt-0 pb-2">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <span class="total-sub-value" v-on="on">
                                            {{ formatPrice(parseFloat(_.get(totalData, 'initTurnOver', 0))) }}
                                        </span>
                                    </template>
                                    <span>Doanh thu khởi tạo</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="total-wrapper">
                        <v-row class="mt-2">
                            <v-col cols="2" class="text-center">
                                <b>%</b>
                            </v-col>
                            <v-col cols="10" class="text-left total-value">
                                {{ _.get(totalData, 'successLatch', '0.00') }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="1" class="py-0"></v-col>
                            <v-col cols="11" class="text-left py-0 total-sub-text">
                                Tỉ lệ chốt thành công
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-right pt-0 pb-2">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <span class="total-sub-value" v-on="on">
                                            {{ _.get(totalData, 'initLatch', '0.00') }} %
                                        </span>
                                    </template>
                                    <span>Tỉ lệ chốt khởi tạo</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </div>
                    <div class="total-wrapper">
                        <v-row class="mt-2">
                            <v-col cols="2" class="text-center">
                                <b>VNĐ</b>
                            </v-col>
                            <v-col cols="10" class="text-left total-value">
                                {{ formatPrice(Math.round(parseFloat(_.get(totalData, 'successArpu', '0.00')))) }}
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="1" class="py-0"></v-col>
                            <v-col cols="11" class="text-left py-0 total-sub-text">
                                ARPU thành công
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" class="text-right pt-0 pb-2">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <span class="total-sub-value" v-on="on">
                                            {{ formatPrice(Math.round(parseFloat(_.get(totalData, 'initArpu', '0.00')))) }}
                                        </span>
                                    </template>
                                    <span>ARPU khởi tạo</span>
                                </v-tooltip>
                            </v-col>
                        </v-row>
                    </div>
                </v-card-text>
                <v-card-text v-else>
                    <common-no-result />
                </v-card-text>
            </v-card>
        </v-col>
        <v-col cols="8">
            <v-card class="mb-0">
                <v-card-title>
                    <div class="report-title">
                        Nhóm ngành
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-simple-table class="table-layout pa-5 pb-0 pt-2 mb-3">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th></th>
                                    <template v-for="(item, index) in header">
                                        <th :key="'header_' + index">{{ item }}</th>
                                    </template>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="header-tr">
                                    <td colspan="100" class="text-left">Doanh thu</td>
                                </tr>
                                <tr>
                                    <td class="text-left">Doanh thu thành công</td>
                                    <template v-for="(value, index) in successTurnOver">
                                        <td :key="'successTurnOver_' + index">{{ formatPrice(parseFloat(value)) }}</td>
                                    </template>
                                </tr>
                                <tr>
                                    <td class="text-left">Doanh thu khởi tạo</td>
                                    <template v-for="(value, index) in initTurnOver">
                                        <td :key="'initTurnOver_' + index">{{ formatPrice(parseFloat(value)) }}</td>
                                    </template>
                                </tr>

                                <tr class="header-tr">
                                    <td colspan="100" class="text-left">Tỉ lệ chốt</td>
                                </tr>
                                <tr>
                                    <td class="text-left">Tỉ lệ chốt thành công</td>
                                    <template v-for="(value, index) in successLatch">
                                        <td :key="'successLatch_' + index">{{ value }} %</td>
                                    </template>
                                </tr>
                                <tr>
                                    <td class="text-left">Tỉ lệ chốt khởi tạo</td>
                                    <template v-for="(value, index) in initLatch">
                                        <td :key="'initLatch_' + index">{{ value }} %</td>
                                    </template>
                                </tr>

                                <tr class="header-tr">
                                    <td colspan="100" class="text-left">ARPU</td>
                                </tr>
                                <tr>
                                    <td class="text-left">ARPU thành công</td>
                                    <template v-for="(value, index) in successArpu">
                                        <td :key="'successArpu_' + index">{{ formatPrice(Math.round(parseFloat(value))) }}</td>
                                    </template>
                                </tr>
                                <tr>
                                    <td class="text-left">ARPU khởi tạo</td>
                                    <template v-for="(value, index) in initArpu">
                                        <td :key="'initArpu_' + index">{{ formatPrice(Math.round(parseFloat(value))) }}</td>
                                    </template>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: {
        totalData: {
            type: Object,
            default: () => {}
        },
        initArpu: {
            type: Array,
            default: () => []
        },
        initLatch: {
            type: Array,
            default: () => []
        },
        initTurnOver: {
            type: Array,
            default: () => []
        },
        successArpu: {
            type: Array,
            default: () => []
        },
        successLatch: {
            type: Array,
            default: () => []
        },
        successTurnOver: {
            type: Array,
            default: () => []
        },
        header: {
            type: Array,
            default: () => []
        },
    }
}
</script>

<style scoped>
.v-card {
    overflow: visible !important;
    overflow-x: hidden;
}

.sticky-total-card {
    position: sticky;
    top: 40px;
}

.total-report-card {
    margin-bottom: 0px !important;
    height: calc(100% - 30px) !important;
}

.total-wrapper {
    margin-top: 10%;
    border-bottom: thin solid #e2e2e2;
}

.report-title {
    position: absolute;
    top: -30px;
    background-color: #e91e63;
    padding: 5px 20px;
    color: white;
    border-radius: 5px;
}

.total-value {
    font-size: 36px;
    font-weight: 500;
}

.total-sub-text {
    color: #979797;
    font-weight: 400;
}

.total-sub-value {
    color: #979797;
    background-color: whitesmoke;
    padding: 2px 20px;
    border-radius: 10px;
}

table tbody tr {
    height: 40px !important;
    padding: 0px;
}

table thead th {
    font-weight: bold;
}

table tbody td {
    font-weight: 500;
}

table tbody tr.header-tr {
    background-color: rgba(0, 0, 0, 0.11) !important;
}

table tbody tr.header-tr td {
    font-size: 16px;
}
</style>